module.exports = __webpack_public_path__ + "img/banner.7f2ea88d.jpg";